import React, { useState, useEffect, useRef } from "react";
import emailjs from 'emailjs-com';


const redirectToThankYouPage = () => {
  window.location.href = "/Thankyou";
};

const ContactForm = () => {
const FormImg = "https://izbassetsmain.blob.core.windows.net/izbwebassets/FromImg.png";

const form = useRef();


  // State variables
  const [key, setKey] = useState(0);
  const [selectedMain, setSelectedMain] = useState("");
  const [selectedSub, setSelectedSub] = useState("");
  const [selectedSpecific, setSelectedSpecific] = useState("");


  // Handle Main Category Change
  const handleMainChange = (e) => {
    setSelectedMain(e.target.value);
    setSelectedSub("");
    setSelectedSpecific("");
  };

  // Handle Sub Category Change
  const handleSubChange = (e) => {
    setSelectedSub(e.target.value);
    setSelectedSpecific(""); 
  };

const sendEmail = (e) => {
  e.preventDefault();

  // emailjs.sendForm('service_og453gt', 'template_2gzvl0w', form.current, 'a_V6asgLs6P7WhZHS')
  emailjs.sendForm('service_1l8qgxr', 'template_mw7tnpa', form.current, 'W-sLT-cWR66Dsys3M')

  .then((result) => {
    console.log(result.text);
    e.target.reset();
redirectToThankYouPage(); 

}, (error) => {
    console.log(error.text);
});
    e.target.reset()
};
  const FormImgStyle = {
    backgroundImage: `url(${FormImg})`,
    height: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    overflow: "hidden",
    
  };


  useEffect(() => {
    setKey(prevKey => prevKey + 1);
  }, []);

  return (
    <section className="apply-form-area" key={key}>
      <div className="container">
        <div className="row">
          <div className="heading mb-3">
            <h1 className="text-center py-2" style={{ color: "#484848" }}>
              Request a Call Back or File a Grievance
            </h1>
            <p className="text-center pb-2" style={{ color: "#949292" }}>
              Committed to helping you meet all your banking needs.
            </p>
          </div>
          <div className="col-xl-6 col-xl-6 px-0">
            <div
              className="overview-content-box-one mx-0 px-5 pb-5 d-flex flex-column justify-content-end text-white text-center"
              style={FormImgStyle}
            >
              <h3 className="text-white py-1">
                Secure your child future with our
              </h3>
              <h2 className="text-white py-2">SAVE PLUS ACCOUNT</h2>
              <p style={{fontSize:"16px"}}>
                Exclusively designed savings account <br />
                to inculcate savings habits in parents <br />
                and guardians for their children.
              </p>
            </div>
          </div>
          <div className="col-xl-6 col-md-6 px-0" style={{backgroundColor:"#FFF5E7"}}>
            <div className="apply-form-box__content mx-0">
              <form
              ref={form} 
              onSubmit={sendEmail}
                id="apply-form"
                name="apply_form"
                className="default-form2"
                action="index.html"
                method="post"
              >
                <div className="row">
                  <div className="col-xl-12">
                    <div className="form-group">
                      <label>Name</label>
                      <div className="input-box">
                        <input
                          type="text"
                          name="form_name"
                          id="formName"
                          placeholder="Your Name"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-12">
                    <div className="form-group">
                      <label>Email</label>
                      <div className="input-box">
                        <input
                          type="email"
                          name="form_email"
                          id="formEmail"
                          placeholder="Email"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-12">
                    <div className="form-group">
                      <label>Phone Number</label>
                      <div className="input-box">
                        <input
                          type="text"
                          name="form_phone"
                          defaultValue=""
                          id="formPhone"
                          placeholder="Phone"
                          required

                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">

                  <div className="col-xl-12">
                    <div className="form-group">
                      <label>Select Product Type</label>
                      <div className="select-box clearfix">
                        <select onChange={handleMainChange} className="wide w-100 border-0" name="form_main_category" placeholder="Select" required>
                          <option value="">Select</option>
                          <option value="Personal Banking">Personal Banking</option>
                          <option value="Business Banking">Business Banking</option>
                          <option value="Credit">Credit</option>
                          <option value="Insurance">Insurance</option>
                          <option value="Complaints">Complaints</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {selectedMain && selectedMain !== "Complaints" && selectedMain !== "Others" && (
                    <div className="col-xl-12">
                      <div className="form-group">
                        <>
                          <label>Select Category</label>
                          <div className="flex select-box clearfix">
                            <select value={selectedSub} onChange={handleSubChange} className="wide w-100 border-0" name="form_sub_category" required>
                              <option value="">Select</option>
                              {selectedMain === "Personal Banking" && (
                                <>
                                  <option value="Savings Account">Savings Account</option>
                                  <option value="Premier Banking">Premier Banking</option>
                                  <option value="Personal Banking Credit">Personal Banking Credit</option>
                                  <option value="Bhumi Fixed Deposit A/C">Bhumi Fixed Deposit A/C</option>
                                  <option value="Indo Fast Serve">Indo Fast Serve</option>
                                </>
                              )}
                              {selectedMain === "Business Banking" && (
                                <>
                                  <option value="Privilege Current Account">Privilege Current Account</option>
                                  <option value="Classic Current Account">Classic Current Account</option>
                                  <option value="SME Current Account">SME Current Account</option>
                                </>
                              )}
                              {selectedMain === "Credit" && (
                                <>
                                  <option value="MSME Loan">MSME Loan</option>
                                  <option value="Term Loan">Term Loan</option>
                                  <option value="Indo Vehicle Finance">Indo Vehicle Finance</option>
                                  <option value="Agro Finance">Agro Finance</option>
                                  <option value="Equity Release">Equity Release</option>
                                  <option value="Business Loan">Business Loan</option>
                                  <option value="Working Capital Finance">Working Capital Finance</option>
                                  <option value="Lease Rental Discounting">Lease Rental Discounting</option>
                                  <option value="Indo Green Asset Finance">Indo Green Asset Finance</option>
                                </>
                              )}
                              {selectedMain === "Insurance" && (
                                <>
                                  <option value="General Insurance">General Insurance</option>
                                  <option value="Life Assurance">Life Assurance</option>
                                </>
                              )}
                            </select>
                          </div>
                        </>
                      </div>
                    </div>
                  )}

                  {selectedSub && ["Savings Account", "Personal Banking Credit", "General Insurance", "Life Assurance"].includes(selectedSub) && (
                    <div className="col-xl-12">
                      <div className="form-group">
                        <>
                          <label>Select Specific Plan</label>
                          <div className="select-box clearfix">
                            <select value={selectedSpecific} onChange={(e) => setSelectedSpecific(e.target.value)} className="wide w-100 border-0" name="form_specific_plan" required>
                              <option value="">Select</option>
                              {selectedSub === "Savings Account" && (
                                <>
                                  <option value="Save Plus Bank A/C">Save Plus Bank A/C</option>
                                  <option value="Classic Saving Account">Classic Saving Account</option>
                                  <option value="Privilege Savings Account">Privilege Savings Account</option>
                                  <option value="Tisunge Savings Account">Tisunge Savings Account</option>
                                  <option value="Tonse Savings Account">Tonse Savings Account</option>
                                </>
                              )}
                              {selectedSub === "Personal Banking Credit" && (
                                <>
                                  <option value="Indo Home Loan">Indo Home Loan</option>
                                  <option value="Personal Loan">Personal Loan</option>
                                  <option value="Indo Vehicle Loan">Indo Vehicle Loan</option>
                                  <option value="Indo Green Asset Finance">Indo Green Asset Finance</option>
                                </>
                              )}
                              {selectedSub === "General Insurance" && (
                                <>
                                  <option value="Household Contents Insurance">Household Contents Insurance</option>
                                  <option value="House Owners Insurance">House Owners Insurance</option>
                                  <option value="Smart Devices">Smart Devices</option>
                                  <option value="Private Motor Comprehensive Insurance">Private Motor Comprehensive Insurance</option>
                                  <option value="Commercial Motor Comprehensive Insurance">Commercial Motor Comprehensive Insurance</option>
                                </>
                              )}
                              {selectedSub === "Life Assurance" && (
                                <>
                                  <option value="IZB Smart Child Education Plan">IZB Smart Child Education Plan</option>
                                  <option value="IZB Flexi Farewell Funeral Plan">IZB Flexi Farewell Funeral Plan</option>
                                </>
                              )}
                            </select>
                          </div>
                        </>
                      </div>
                    </div>
                  )}

                  <div className="col-xl-12">
                    <div className="form-group">
                      <label>Message</label>
                      <div className="input-box">
                        <textarea
                          style={{ width: "100%", border:"none" }}
                          type="text"
                          name="form_message"
                          id="formMessage"
                          placeholder=""
                          required=""
                          defaultValue={""}
                        />
                      </div>
                    </div>
                  </div>

            </div>


                <div className="row">
                  <div className="col-xl-12">
                    <div className="button-box" >
                      <button className="btn-one" style={{borderRadius:"10px"}} type="submit">
                        <span className="txt">Submit </span>
                      </button>
                    </div>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;